// extracted by mini-css-extract-plugin
module.exports = {"button":"VariableTypeSelection_button__3pk--"};